import { render } from "./RangeSliderWidget.vue?vue&type=template&id=e364b8d8"
import script from "./RangeSliderWidget.vue?vue&type=script&lang=js"
export * from "./RangeSliderWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__